// data and stuff
import { imgSrc } from "../utils/backend";

type props = { size: number, middle?: boolean }

function Emoji({ size, middle, src, alt }: props & { src: string, alt: string }) {
  const style = middle ? {margin: `0px ${size / 7}px`} : { marginRight: `${size / 7}px`}
  return <img
    src={imgSrc(src)}
    alt={alt}
    width={`${size}px`}
    height={`${size}px`}
    style={{...style, verticalAlign: "bottom"}}
  />
}

export function GB({size, middle}: props) {
  return <Emoji size={size} middle={middle} src="currency/gb.png" alt="gb"/>
}

export function EM({ size, middle }: props) {
  return <Emoji size={size} middle={middle} src="currency/em.png" alt="em"/>
}